import { render, staticRenderFns } from "./sale-goods-info.vue?vue&type=template&id=3253d7fd&scoped=true&"
import script from "./sale-goods-info.vue?vue&type=script&lang=js&"
export * from "./sale-goods-info.vue?vue&type=script&lang=js&"
import style0 from "./sale-goods-info.vue?vue&type=style&index=0&id=3253d7fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3253d7fd",
  null
  
)

export default component.exports